import { Project } from '../types';

export const featuredProjects: Project[] = [
  {
    id: '1',
    title: 'Hello Old Days E-Commerce Platform',
    client: 'Hello Old Days',
    category: 'ecommerce',
    industry: 'Fashion Retail',
    challenge: 'Client was struggling with high fees from Shopee and other marketplaces cutting into profits. Needed their own branded online store to control costs and customer experience',
    solution: 'Built a complete e-commerce platform with zero marketplace fees, direct customer ownership, advanced product management, and integrated payment processing',
    impact: 'Eliminated marketplace fees (saving 15-20% per sale), increased profit margins by 40%, gained direct customer relationships, and achieved 35% higher conversion rates',
    screenshots: ['/projects/screencapture-helloolddays-2026-01-09-22_48_12.webp'],
    metrics: {
      conversion: '+35%',
      users: '25K+ monthly',
      revenue: '+40% profit margins'
    }
  },
   {
  id: '3',
    title: 'Vault+ Secure Data & Access Management System',
    client: 'Internal / Private Clients',
    category: 'mobile',
    industry: 'Cybersecurity & Data Management',
    challenge: 'Sensitive files, credentials, and system access were stored insecurely and managed manually',
    solution: 'Developed Vault+, a secure web-based system for encrypted data storage, role-based access control, activity logs, and admin management',
    impact: 'Improved data security, access accountability, and internal compliance',
    screenshots: ['/projects/mobileapp.png'],
    metrics: {
      security: 'Encrypted storage',
      access: 'Role-based control'
    }
  },
  {
    id: '3',
    title: 'Bulk SMS & Notification System',
    client: 'Local Businesses (PH)',
    category: 'system',
    industry: 'Marketing & Communications',
    challenge: 'Clients needed a reliable way to send bulk SMS and notifications',
    solution: 'Built a web-based SMS system with contact management, message scheduling, API integration, and delivery logs',
    impact: 'Enabled faster customer communication and campaign execution',
    screenshots: ['/projects/screencapture-skysms-skyio-site-2026-01-09-22_58_08.webp'],
    metrics: {
      users: 'Multiple business accounts',
      usage: 'Thousands of SMS sent'
    }
  }
];

export const allProjects: Project[] = [
  ...featuredProjects,
  {
    id: '4',
    title: 'Corporate Business Website',
    client: 'SteelCorp Industries',
    category: 'website',
    industry: 'Manufacturing',
    challenge: 'Outdated website with no clear service presentation',
    solution: 'Designed and developed a modern corporate website with service pages, inquiry forms, and responsive layout',
    impact: 'Improved online credibility and client inquiries',
    screenshots: ['/projects/global.png']
  },
  {
    id: '5',
    title: 'E-Commerce Website with Admin Panel',
    client: 'Online Seller PH',
    category: 'ecommerce',
    industry: 'Retail',
    challenge: 'Manual order processing and no centralized product management',
    solution: 'Created a custom e-commerce website with product catalog, checkout, order management, and admin dashboard',
    impact: 'Streamlined order handling and improved customer experience',
    screenshots: ['/projects/screencapture-store-skyio-site-admin-2026-01-09-23_06_44.webp'],
    metrics: {
      orders: 'Thousands processed',
      conversion: 'Improved checkout flow'
    }
  },
  {
    id: '6',
    title: 'Vault+ Secure Data & Access Management System',
    client: 'Internal / Private Clients',
    category: 'mobile',
    industry: 'Cybersecurity & Data Management',
    challenge: 'Sensitive files, credentials, and system access were stored insecurely and managed manually',
    solution: 'Developed Vault+, a secure web-based system for encrypted data storage, role-based access control, activity logs, and admin management',
    impact: 'Improved data security, access accountability, and internal compliance',
    screenshots: ['/projects/mobileapp.png'],
    metrics: {
      security: 'Encrypted storage',
      access: 'Role-based control'
    }
  }
];
